import React from 'react';
import { FEE_SETTLEMENT_DISCLAIMER } from './productCopy';

/** Shared locked-funds trust messaging for challenge confirmations. */
export const ESCROW_TRUST_LINES = [
  'Challenge amounts are moved to locked funds until the challenge settles.',
  'Neither player can access locked funds until settlement.',
  'LockedIn does not change challenge results.',
  'Free accounts: 5% platform service fee on the challenge pool at settlement. LockedIn Plus: 2%.',
  FEE_SETTLEMENT_DISCLAIMER,
];

export function EscrowTrustBlock({ className = '' }) {
  return (
    <div
      className={`text-left rounded-xl border border-emerald-500/25 bg-emerald-500/5 p-4 space-y-1.5 ${className}`}
    >
      {ESCROW_TRUST_LINES.map((line) => (
        <p key={line} className="text-xs sm:text-sm text-gray-300 font-medium leading-relaxed">
          {line}
        </p>
      ))}
    </div>
  );
}

export function lockInConfirmationNote(stake, subscriptionProfile) {
  const s = Number(stake) || 0;
  const pool = s * 2;
  return (
    `Review your challenge before locking funds. Your entry: $${s.toFixed(2)}. `
    + `Challenge pool: $${pool.toFixed(2)}. `
    + 'Estimated winner transfer depends on the platform service fee at settlement. '
    + FEE_SETTLEMENT_DISCLAIMER
  );
}
